import { createCtpClient } from "./builder";
import { createApiBuilderFromCtpClient } from "@commercetools/platform-sdk";

export const createClient = (token: string) =>
    createApiBuilderFromCtpClient(createCtpClient(token)).withProjectKey({
        projectKey: process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY,
    });
